import { SettingsForm, type FieldSpec } from "../SettingsForm.js";

const FIELDS: FieldSpec[] = [
  { kind: "group", label: "Passwortregeln" },
  { kind: "number", key: "passwordMinLength", label: "Mindestlänge", min: 8, max: 128, step: 1, suffix: "Zeichen" },
  { kind: "checkbox", key: "passwordRequireUppercase", label: "Großbuchstabe erforderlich" },
  { kind: "checkbox", key: "passwordRequireNumber", label: "Ziffer erforderlich" },
  { kind: "checkbox", key: "passwordRequireSymbol", label: "Sonderzeichen erforderlich" },

  { kind: "group", label: "Anmeldung & Session" },
  { kind: "checkbox", key: "twoFactorRequired", label: "Zwei-Faktor-Authentifizierung verpflichtend" },
  { kind: "number", key: "sessionTimeoutMinutes", label: "Session-Timeout", min: 5, max: 10080, step: 5, suffix: "Minuten" },
  { kind: "number", key: "maxLoginAttempts", label: "Max. Login-Versuche", min: 1, max: 50, step: 1 },
  { kind: "number", key: "lockoutMinutes", label: "Sperrdauer nach Überschreitung", min: 1, max: 1440, step: 1, suffix: "Minuten" },

  { kind: "group", label: "API-Zugriff" },
  { kind: "checkbox", key: "apiAccessEnabled", label: "Programmatischer API-Zugriff erlaubt", help: "API-Tokens werden später als verschlüsselte Secrets verwaltet (isSecret/encrypted vorbereitet)." },
];

const ENFORCEMENT_NOTE = (
  <div className="skeleton-note">
    <span>ℹ️</span>
    <span>
      <strong>Status: qa_ready.</strong> Diese Werte werden zentral gespeichert und bei jeder Änderung
      auditiert. Die <strong>Durchsetzung</strong> im Login-/Auth-Flow (Passwort-Policy, 2FA, Account-Lockout)
      sowie Secrets/Verschlüsselung folgen in einem späteren Inkrement zusammen mit Voll-RBAC.
    </span>
  </div>
);

export function SicherheitSection() {
  return (
    <SettingsForm
      category="security"
      title="Sicherheit"
      intro="Passwortregeln, Zwei-Faktor-Authentifizierung, Session- und Login-Verhalten sowie API-Zugriff."
      fields={FIELDS}
      footer={ENFORCEMENT_NOTE}
    />
  );
}
